import { render, staticRenderFns } from "./vsDivider.vue?vue&type=template&id=2ecf82fb&lang=html&"
import script from "./vsDivider.vue?vue&type=script&lang=js&"
export * from "./vsDivider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsDivider.vue"
export default component.exports